import { Box } from "@mui/material";
import styled from "styled-components";
import { color } from "~/assets/styles/colors";



export const BoxContainer = styled(Box)`
	background-color: #fff;
	color: ${color.softBlack};
	padding: 10px 20px;
	border-radius: 5px;
	margin-right: 22px;
	margin-top: -5px;
	font-size: 12px;
	p {
		padding: 0px;
		margin: 0px;
	}

	@media screen and (max-width: 770px) {
		font-size: 8px;
		background-color: ${color.primary};
		color: #fff;
	}
`;
